
export const extraSmall = '@media (max-width: 576px)';
export const small = '@media (min-width: 577px) and (max-width: 767px)';
export const medium = '@media (min-width: 768px) and (max-width: 991px)';
export const large = '@media (min-width: 992px) and (max-width: 1199px)';
export const larger = '@media (min-width: 1200px) and (max-width: 1320px)';
export const extraLarge = '@media (min-width: 1321px)';